import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
/******/ var __webpack_modules__ = ({

/***/ 8753:
/***/ ((module) => {

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),

/***/ 1801:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

var __webpack_unused_export__;
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
__webpack_require__(8753);var f=__webpack_require__(810),g=60103;__webpack_unused_export__=60107;if("function"===typeof Symbol&&Symbol.for){var h=Symbol.for;g=h("react.element");__webpack_unused_export__=h("react.fragment")}var m=f.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n=Object.prototype.hasOwnProperty,p={key:!0,ref:!0,__self:!0,__source:!0};
function q(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n.call(a,b)&&!p.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return{$$typeof:g,type:c,key:e,ref:l,props:d,_owner:m.current}}exports.jsx=q;exports.jsxs=q;


/***/ }),

/***/ 3704:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {



if (true) {
  module.exports = __webpack_require__(1801);
} else {}


/***/ }),

/***/ 810:
/***/ ((module) => {

var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
module.exports = __WEBPACK_EXTERNAL_MODULE_react__;

/***/ })

/******/ });
/************************************************************************/
/******/ // The module cache
/******/ var __webpack_module_cache__ = {};
/******/ 
/******/ // The require function
/******/ function __webpack_require__(moduleId) {
/******/ 	// Check if module is in cache
/******/ 	var cachedModule = __webpack_module_cache__[moduleId];
/******/ 	if (cachedModule !== undefined) {
/******/ 		return cachedModule.exports;
/******/ 	}
/******/ 	// Create a new module (and put it into the cache)
/******/ 	var module = __webpack_module_cache__[moduleId] = {
/******/ 		// no module.id needed
/******/ 		// no module.loaded needed
/******/ 		exports: {}
/******/ 	};
/******/ 
/******/ 	// Execute the module function
/******/ 	__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 
/******/ 	// Return the exports of the module
/******/ 	return module.exports;
/******/ }
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  y: () => (/* binding */ IconBenefitsStretchfabric)
});

;// CONCATENATED MODULE: ../../../../node_modules/tslib/tslib.es6.js
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

// EXTERNAL MODULE: ../../../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(3704);
;// CONCATENATED MODULE: ./icons/IconBenefitsStretchfabric.tsx


const IconBenefitsStretchfabric = (props) => {
    const { className, brand, dataTestId } = props, rest = __rest(props, ["className", "brand", "dataTestId"]);
    if (brand === 'ck')
        return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-benefits-stretchfabric-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("title", { children: 'Stretch Fabric Icon' }), (0,jsx_runtime.jsx)("desc", { children: 'Created with Sketch.' }), (0,jsx_runtime.jsx)("defs", {}), (0,jsx_runtime.jsx)("g", Object.assign({ id: "Spots-Flow", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Icons-", transform: "translate(-507.000000, -284.000000)", fill: "#00285E" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Stretch-Fabric-Icon-", transform: "translate(508.000000, 284.000000)" }, { children: (0,jsx_runtime.jsxs)("g", Object.assign({ id: "Stretch-Fabric-Icon" }, { children: [(0,jsx_runtime.jsx)("path", { d: "M15.0021753,0.969995048 C14.9776603,0.969995048 14.9538883,0.969995048 14.9286305,0.969995048 C6.94418731,1.01010895 0.480413603,7.5375325 0.519786089,15.521685 C0.559901453,23.4813235 7.0481901,29.930005 14.9992038,29.930005 C15.0229758,29.930005 15.0482337,29.930005 15.0720057,29.930005 C18.9401668,29.9106909 22.5691215,28.3863625 25.2910232,25.6385601 C28.0121821,22.8900149 29.5001649,19.2463353 29.4808501,15.378315 C29.4615353,11.5102947 27.9378943,7.88221493 25.189249,5.16041228 C22.4584328,2.45643803 18.8428499,0.969995048 15.0021753,0.969995048 Z M14.9992038,30.45 C6.76218242,30.4507429 0.0406303557,23.7702922 0.000514991892,15.5246564 C-0.040343249,7.25302092 6.65520811,0.490856754 14.9256589,0.45 L15.0021753,0.45 C18.9810251,0.45 22.7258686,1.98992819 25.5547446,4.7912158 C28.4021925,7.61033181 29.9808064,11.3691532 30.0001212,15.3760864 C30.0209218,19.3822768 28.4794518,23.156698 25.6602331,26.0040423 C22.8410145,28.8513867 19.0813135,30.429943 15.0749772,30.45 L14.9992038,30.45 Z", id: "Fill-19", stroke: "#00174F", strokeWidth: 0.5 }), (0,jsx_runtime.jsx)("path", { d: "M24.1901707,9.02890244 L24.1901707,10.3686585 C24.1901707,10.4293902 24.2143171,10.4842683 24.254561,10.5237805 C24.2948049,10.5632927 24.3496829,10.5881707 24.4104146,10.5881707 C24.531878,10.5881707 24.6306585,10.490122 24.6306585,10.3686585 L24.6306585,8.49841463 C24.6306585,8.37695122 24.531878,8.27890244 24.4104146,8.27890244 L22.5401707,8.27890244 C22.4187073,8.27890244 22.3199268,8.37695122 22.3199268,8.49841463 C22.3199268,8.61987805 22.4187073,8.71865854 22.5401707,8.71865854 L23.8791951,8.71865854", id: "Fill-1" }), (0,jsx_runtime.jsx)("path", { d: "M5.80317073,8.71836585 L7.14219512,8.71836585 C7.20292683,8.71836585 7.25780488,8.6934878 7.29804878,8.65397561 C7.33829268,8.61373171 7.36243902,8.55885366 7.36243902,8.49812195 C7.36243902,8.37665854 7.26365854,8.27860976 7.14219512,8.27860976 L5.27268293,8.27860976 C5.1504878,8.27860976 5.05317073,8.37665854 5.05317073,8.49812195 L5.05317073,10.3683659 C5.05317073,10.4898293 5.1504878,10.587878 5.27268293,10.587878 C5.39414634,10.587878 5.49219512,10.4898293 5.49219512,10.3683659 L5.49146341,9.02860976", id: "Fill-3" }), (0,jsx_runtime.jsx)("path", { d: "M14.8502195,12.6609512 C7.42192683,12.6609512 5.43168293,8.92631707 5.41265854,8.88826829 L5.8685122,8.65558537 C5.88607317,8.6885122 7.79509756,12.1487561 14.8502195,12.1487561 C21.9404634,12.1487561 23.8143659,8.69143902 23.8319268,8.65704878 L24.2907073,8.88534146 C24.2724146,8.92339024 22.3531463,12.6609512 14.8502195,12.6609512", id: "Fill-5" }), (0,jsx_runtime.jsx)("path", { d: "M5.49234146,21.8184146 L5.49234146,20.4793902 C5.49234146,20.4186585 5.46819512,20.3630488 5.42795122,20.3235366 C5.38770732,20.2840244 5.33282927,20.2591463 5.27209756,20.2591463 C5.15063415,20.2591463 5.05185366,20.3579268 5.05185366,20.4793902 L5.05185366,22.3496341 C5.05185366,22.4710976 5.15063415,22.5691463 5.27209756,22.5691463 L7.14234146,22.5691463 C7.26380488,22.5691463 7.36258537,22.4710976 7.36258537,22.3496341 C7.36258537,22.227439 7.26380488,22.1293902 7.14234146,22.1293902 L5.80404878,22.1293902", id: "Fill-7" }), (0,jsx_runtime.jsx)("path", { d: "M23.8793415,22.1292439 L22.5403171,22.1292439 C22.4795854,22.1292439 22.4239756,22.154122 22.3844634,22.1936341 C22.3449512,22.233878 22.3200732,22.2887561 22.3200732,22.3494878 C22.3200732,22.4709512 22.4188537,22.569 22.5403171,22.569 L24.410561,22.569 C24.5320244,22.569 24.6293415,22.4709512 24.6293415,22.3494878 L24.6293415,20.4792439 C24.6293415,20.3577805 24.5320244,20.2597317 24.410561,20.2597317 C24.2890976,20.2597317 24.1903171,20.3577805 24.1903171,20.4792439 L24.1910488,21.8182683", id: "Fill-9" }), (0,jsx_runtime.jsx)("path", { d: "M23.8143659,22.1928293 C23.7968049,22.1591707 21.884122,18.6996585 14.8319268,18.6996585 C7.75339024,18.6996585 5.86778049,22.1577073 5.8487561,22.1928293 L5.39363415,21.9579512 C5.47339024,21.803561 7.42046341,18.1867317 14.8319268,18.1867317 C22.2426585,18.1867317 24.2504634,21.9206341 24.2702195,21.9586829 L23.8143659,22.1928293 Z", id: "Fill-11" }), (0,jsx_runtime.jsx)("path", { d: "M22.668878,15.6799756 L7.0337561,15.6799756 C6.89180488,15.6799756 6.77765854,15.5650976 6.77765854,15.423878 C6.77765854,15.2826585 6.89180488,15.1677805 7.0337561,15.1677805 L22.668878,15.1677805 C22.8100976,15.1677805 22.9249756,15.2826585 22.9249756,15.423878 C22.9249756,15.5650976 22.8100976,15.6799756 22.668878,15.6799756", id: "Fill-13" }), (0,jsx_runtime.jsx)("path", { d: "M22.7989756,15.6435366 L21.8514146,16.5903659 C21.8082439,16.6342683 21.7870244,16.689878 21.7870244,16.7454878 C21.7870244,16.802561 21.8082439,16.8581707 21.8514146,16.9013415 C21.9377561,16.9876829 22.0775122,16.9876829 22.163122,16.9013415 L23.4845854,15.5791463 C23.5716585,15.4928049 23.5716585,15.3537805 23.4845854,15.2689024 L22.163122,13.9459756 C22.0775122,13.8603659 21.9377561,13.8603659 21.8514146,13.9459756 C21.7658049,14.0315854 21.7658049,14.1713415 21.8514146,14.2569512 L22.7989756,15.2037805", id: "Fill-15" }), (0,jsx_runtime.jsx)("path", { d: "M6.90292683,15.2040732 L7.8504878,14.2572439 C7.89292683,14.2133415 7.91487805,14.1577317 7.91487805,14.1013902 C7.91487805,14.0450488 7.89292683,13.9887073 7.8504878,13.9462683 C7.76414634,13.8599268 7.62439024,13.8599268 7.53878049,13.9462683 L6.21731707,15.2677317 C6.1302439,15.3540732 6.1302439,15.4938293 6.21731707,15.579439 L7.53878049,16.9016341 C7.62439024,16.9879756 7.76414634,16.9879756 7.8504878,16.9016341 C7.93536585,16.8160244 7.93536585,16.6762683 7.8504878,16.5913902 L6.90292683,15.6438293", id: "Fill-17" })] })) })) })) }))] })));
    return ((0,jsx_runtime.jsxs)("svg", Object.assign({ className: className, "data-testid": dataTestId || 'icon-benefits-stretchfabric-svg', width: "1em", height: "1em", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest, { children: [(0,jsx_runtime.jsx)("title", { children: 'Stretch Fabric Icon' }), (0,jsx_runtime.jsx)("desc", { children: 'Created with Sketch.' }), (0,jsx_runtime.jsx)("defs", {}), (0,jsx_runtime.jsx)("g", Object.assign({ id: "Spots-Flow", stroke: "none", strokeWidth: 1, fill: "none", fillRule: "evenodd" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Icons-", transform: "translate(-507.000000, -284.000000)", fill: "#00285E" }, { children: (0,jsx_runtime.jsx)("g", Object.assign({ id: "Stretch-Fabric-Icon-", transform: "translate(508.000000, 284.000000)" }, { children: (0,jsx_runtime.jsxs)("g", Object.assign({ id: "Stretch-Fabric-Icon" }, { children: [(0,jsx_runtime.jsx)("path", { d: "M15.0021753,0.969995048 C14.9776603,0.969995048 14.9538883,0.969995048 14.9286305,0.969995048 C6.94418731,1.01010895 0.480413603,7.5375325 0.519786089,15.521685 C0.559901453,23.4813235 7.0481901,29.930005 14.9992038,29.930005 C15.0229758,29.930005 15.0482337,29.930005 15.0720057,29.930005 C18.9401668,29.9106909 22.5691215,28.3863625 25.2910232,25.6385601 C28.0121821,22.8900149 29.5001649,19.2463353 29.4808501,15.378315 C29.4615353,11.5102947 27.9378943,7.88221493 25.189249,5.16041228 C22.4584328,2.45643803 18.8428499,0.969995048 15.0021753,0.969995048 Z M14.9992038,30.45 C6.76218242,30.4507429 0.0406303557,23.7702922 0.000514991892,15.5246564 C-0.040343249,7.25302092 6.65520811,0.490856754 14.9256589,0.45 L15.0021753,0.45 C18.9810251,0.45 22.7258686,1.98992819 25.5547446,4.7912158 C28.4021925,7.61033181 29.9808064,11.3691532 30.0001212,15.3760864 C30.0209218,19.3822768 28.4794518,23.156698 25.6602331,26.0040423 C22.8410145,28.8513867 19.0813135,30.429943 15.0749772,30.45 L14.9992038,30.45 Z", id: "Fill-19", stroke: "#00174F", strokeWidth: 0.5 }), (0,jsx_runtime.jsx)("path", { d: "M24.1901707,9.02890244 L24.1901707,10.3686585 C24.1901707,10.4293902 24.2143171,10.4842683 24.254561,10.5237805 C24.2948049,10.5632927 24.3496829,10.5881707 24.4104146,10.5881707 C24.531878,10.5881707 24.6306585,10.490122 24.6306585,10.3686585 L24.6306585,8.49841463 C24.6306585,8.37695122 24.531878,8.27890244 24.4104146,8.27890244 L22.5401707,8.27890244 C22.4187073,8.27890244 22.3199268,8.37695122 22.3199268,8.49841463 C22.3199268,8.61987805 22.4187073,8.71865854 22.5401707,8.71865854 L23.8791951,8.71865854", id: "Fill-1" }), (0,jsx_runtime.jsx)("path", { d: "M5.80317073,8.71836585 L7.14219512,8.71836585 C7.20292683,8.71836585 7.25780488,8.6934878 7.29804878,8.65397561 C7.33829268,8.61373171 7.36243902,8.55885366 7.36243902,8.49812195 C7.36243902,8.37665854 7.26365854,8.27860976 7.14219512,8.27860976 L5.27268293,8.27860976 C5.1504878,8.27860976 5.05317073,8.37665854 5.05317073,8.49812195 L5.05317073,10.3683659 C5.05317073,10.4898293 5.1504878,10.587878 5.27268293,10.587878 C5.39414634,10.587878 5.49219512,10.4898293 5.49219512,10.3683659 L5.49146341,9.02860976", id: "Fill-3" }), (0,jsx_runtime.jsx)("path", { d: "M14.8502195,12.6609512 C7.42192683,12.6609512 5.43168293,8.92631707 5.41265854,8.88826829 L5.8685122,8.65558537 C5.88607317,8.6885122 7.79509756,12.1487561 14.8502195,12.1487561 C21.9404634,12.1487561 23.8143659,8.69143902 23.8319268,8.65704878 L24.2907073,8.88534146 C24.2724146,8.92339024 22.3531463,12.6609512 14.8502195,12.6609512", id: "Fill-5" }), (0,jsx_runtime.jsx)("path", { d: "M5.49234146,21.8184146 L5.49234146,20.4793902 C5.49234146,20.4186585 5.46819512,20.3630488 5.42795122,20.3235366 C5.38770732,20.2840244 5.33282927,20.2591463 5.27209756,20.2591463 C5.15063415,20.2591463 5.05185366,20.3579268 5.05185366,20.4793902 L5.05185366,22.3496341 C5.05185366,22.4710976 5.15063415,22.5691463 5.27209756,22.5691463 L7.14234146,22.5691463 C7.26380488,22.5691463 7.36258537,22.4710976 7.36258537,22.3496341 C7.36258537,22.227439 7.26380488,22.1293902 7.14234146,22.1293902 L5.80404878,22.1293902", id: "Fill-7" }), (0,jsx_runtime.jsx)("path", { d: "M23.8793415,22.1292439 L22.5403171,22.1292439 C22.4795854,22.1292439 22.4239756,22.154122 22.3844634,22.1936341 C22.3449512,22.233878 22.3200732,22.2887561 22.3200732,22.3494878 C22.3200732,22.4709512 22.4188537,22.569 22.5403171,22.569 L24.410561,22.569 C24.5320244,22.569 24.6293415,22.4709512 24.6293415,22.3494878 L24.6293415,20.4792439 C24.6293415,20.3577805 24.5320244,20.2597317 24.410561,20.2597317 C24.2890976,20.2597317 24.1903171,20.3577805 24.1903171,20.4792439 L24.1910488,21.8182683", id: "Fill-9" }), (0,jsx_runtime.jsx)("path", { d: "M23.8143659,22.1928293 C23.7968049,22.1591707 21.884122,18.6996585 14.8319268,18.6996585 C7.75339024,18.6996585 5.86778049,22.1577073 5.8487561,22.1928293 L5.39363415,21.9579512 C5.47339024,21.803561 7.42046341,18.1867317 14.8319268,18.1867317 C22.2426585,18.1867317 24.2504634,21.9206341 24.2702195,21.9586829 L23.8143659,22.1928293 Z", id: "Fill-11" }), (0,jsx_runtime.jsx)("path", { d: "M22.668878,15.6799756 L7.0337561,15.6799756 C6.89180488,15.6799756 6.77765854,15.5650976 6.77765854,15.423878 C6.77765854,15.2826585 6.89180488,15.1677805 7.0337561,15.1677805 L22.668878,15.1677805 C22.8100976,15.1677805 22.9249756,15.2826585 22.9249756,15.423878 C22.9249756,15.5650976 22.8100976,15.6799756 22.668878,15.6799756", id: "Fill-13" }), (0,jsx_runtime.jsx)("path", { d: "M22.7989756,15.6435366 L21.8514146,16.5903659 C21.8082439,16.6342683 21.7870244,16.689878 21.7870244,16.7454878 C21.7870244,16.802561 21.8082439,16.8581707 21.8514146,16.9013415 C21.9377561,16.9876829 22.0775122,16.9876829 22.163122,16.9013415 L23.4845854,15.5791463 C23.5716585,15.4928049 23.5716585,15.3537805 23.4845854,15.2689024 L22.163122,13.9459756 C22.0775122,13.8603659 21.9377561,13.8603659 21.8514146,13.9459756 C21.7658049,14.0315854 21.7658049,14.1713415 21.8514146,14.2569512 L22.7989756,15.2037805", id: "Fill-15" }), (0,jsx_runtime.jsx)("path", { d: "M6.90292683,15.2040732 L7.8504878,14.2572439 C7.89292683,14.2133415 7.91487805,14.1577317 7.91487805,14.1013902 C7.91487805,14.0450488 7.89292683,13.9887073 7.8504878,13.9462683 C7.76414634,13.8599268 7.62439024,13.8599268 7.53878049,13.9462683 L6.21731707,15.2677317 C6.1302439,15.3540732 6.1302439,15.4938293 6.21731707,15.579439 L7.53878049,16.9016341 C7.62439024,16.9879756 7.76414634,16.9879756 7.8504878,16.9016341 C7.93536585,16.8160244 7.93536585,16.6762683 7.8504878,16.5913902 L6.90292683,15.6438293", id: "Fill-17" })] })) })) })) }))] })));
};

})();

var __webpack_exports__IconBenefitsStretchfabric = __webpack_exports__.y;
export { __webpack_exports__IconBenefitsStretchfabric as IconBenefitsStretchfabric };
